import { doc, getDoc, getDocFromServer } from "firebase/firestore";
import { db } from "../firebase";
import { GetServiceOpts, EntityGet, EntityServerGet } from "../types";
import { Session } from "./types";
import { transformMetadata, processTimestampFields } from "../utils";

export type SessionGetService<T> = (
  id: string,
  opts?: GetServiceOpts
) => Promise<T | null>;

const get: SessionGetService<EntityGet<Session>> = async (id, opts = {}) => {
  const docRef = doc(db, `/session/${id}`);
  const { disableCache } = opts;
  const getFn = disableCache ? getDocFromServer : getDoc;
  const docSnap = await getFn(docRef);
  if (docSnap.exists()) {
    return processTimestampFields(
      transformMetadata({
        ...docSnap.data(),
        id: docSnap.id,
      } as EntityServerGet<Session>)
    ) as EntityGet<Session>;
  }
  return null;
};

export default get;
